"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedPdfUi = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const front_1 = require("../../../../dsl/front");
/**
 * Component capable to render the `EmbedModule`
 * with the version set `EmbedVersion.Pdf`
 *
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let EmbedPdfUi = class EmbedPdfUi extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        /**
         * Resolved pdf file
         */
        this.resolvedFile = null;
    }
    /**
     * Downloads resolved pdf
     */
    async downloadPdf() {
        if (!this.pdfService || !this.resolvedFile) {
            console.warn('EmbedPdf.ui: Missing prop [pdfService]');
            return;
        }
        await this.pdfService.downland({
            path: this.resolvedFile.fileUrl,
            public: true
        });
    }
    /**
     * @inheritDoc
     */
    async fetchRelated() {
        await this.resolveFile();
    }
    /**
     * Resolves the pdf file, if any.
     */
    async resolveFile() {
        if (typeof this.pdf === 'undefined') {
            return;
        }
        let file = {};
        try {
            file = await this.relatedService.resolve(this.pdf);
        }
        catch (e) {
            console.warn(e);
            return;
        }
        this.resolvedFile = {
            type: front_1.DocumentType.PDF,
            fileDescription: file.title || file.caption || file.alt,
            fileUrl: file.url
        };
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: false }),
    __metadata("design:type", Object)
], EmbedPdfUi.prototype, "description", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: false }),
    __metadata("design:type", Object)
], EmbedPdfUi.prototype, "pdf", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: false, default: null }),
    __metadata("design:type", Object)
], EmbedPdfUi.prototype, "pdfService", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false }),
    __metadata("design:type", Object)
], EmbedPdfUi.prototype, "pdfAsLink", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], EmbedPdfUi.prototype, "relatedService", void 0);
EmbedPdfUi = __decorate([
    vue_property_decorator_1.Component({
        name: 'EmbedPdfUi',
        components: {
            BootstrapLink: front_1.BootstrapLink,
            BootstrapButton: front_1.BootstrapButton,
            BootstrapIcon: front_1.BootstrapIcon
        },
        async created() {
            await this.fetchRelated();
        },
        mounted() {
            this.$emit('ready');
        },
        template: `
    <!--<figure v-if="!pdfAsLink" class="embed-pdf">-->
    <!--  NOTICE!: This package has been removed due to SSR compatibility -->
    <!--  <pdf v-if="resolvedFile" :src="resolvedFile.fileUrl"></pdf>-->
    <!--  <figcaption v-if="description" class="small">-->
    <!--    {{ description }}-->
    <!--  </figcaption>-->
    <!--</figure>-->
    <figure>
      <BootstrapButton v-if="resolvedFile" class="article-action btn-link p-0" @click="downloadPdf">
        <BootstrapIcon name="download" size="small" class="article-action__icon me-1" />
           {{ this.resolvedFile.fileDescription }} [{{ $t('_.downloadPdf') }}]
        </BootstrapButton>
      <figcaption v-if="description" class="small">
        {{ description }}
      </figcaption>
    </figure>
  `
    })
], EmbedPdfUi);
exports.EmbedPdfUi = EmbedPdfUi;
exports.default = EmbedPdfUi;
//# sourceMappingURL=EmbedPdf.ui.js.map